import styled from 'styled-components'
import { motion } from 'framer-motion'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 56px - 24px);
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  gap: 8px;
`

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 56px - 24px - 112px);
  justify-content: center;
  width: 100%;
  overflow: hidden;
  gap: 8px;
`
const containerVariants = {
  hidden: { y: '10%', opacity: 0 },
  show: {
    y: '0%',
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      delayChildren: 0.4,
    },
  },
}
export const SigmalContainer = styled.div`
  padding: 24px;
`
export const Actions = styled(motion.div).attrs({
  variants: containerVariants,
  initial: 'hidden',
  animate: 'show',
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`
